import React, {useState} from 'react';
import TextInput from '../../UI/Form/TextInput';
import useDebounce from '../../hooks/useDebounce';

const SearchListing = ({handleSearch}) => {
  const [search, setSearch] = useState('');

  // setup handle searhc function to search listing when user type in search input  with debounce
  //
  const searchTextHandler = useDebounce(async search_txt => {
    handleSearch(search_txt);
  }, 1000);

  const clearSearch = () => {
    setSearch('');
    handleSearch('');
  };

  return (
    <div className=" flex-none  border border-gray-200 rounded-md py-4 px-5  w-[97%] md:w-[95%]   mx-auto">
      <div className="flex justify-between">
        <h1 className="text-lg font-medium">Search Listing</h1>
        <button className="text-sm text-gray-500" onClick={clearSearch}>
          Clear
        </button>
      </div>
      <div className="flex flex-col gap-2 mt-1">
        <TextInput
          type="text"
          placeholder="Search"
          className="w-full"
          current_data={search}
          update_data={v => {
            setSearch(v);
            searchTextHandler(v);
          }}
        />
      </div>
    </div>
  );
};

export default SearchListing;
